var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedRooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1433_2071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 29.6562V31.2188C0 31.6533 0.349265 32 0.784314 32H4.70588V28.875H0.784314C0.349265 28.875 0 29.2217 0 29.6562ZM27.451 28.875H23.5294V32H27.451C27.886 32 28.2353 31.6521 28.2353 31.2188V29.6562C28.2353 29.2217 27.8873 28.875 27.451 28.875ZM18.8235 17.9375C17.9598 17.9375 17.2549 18.6396 17.2549 19.5C17.2549 20.3604 17.9598 21.0625 18.8235 21.0625C19.6873 21.0625 20.3922 20.3604 20.3922 19.5C20.3922 18.6396 19.6863 17.9375 18.8235 17.9375Z",
    fill: "#224633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1765 7H7.05887C5.75985 7 4.70593 8.11084 4.70593 9.47803V32H23.5295V9.47803C23.5295 8.11084 22.4755 7 21.1765 7ZM18.8236 21.0625C17.9599 21.0625 17.255 20.3604 17.255 19.5C17.255 18.6396 17.9599 17.9375 18.8236 17.9375C19.6873 17.9375 20.3922 18.6396 20.3922 19.5C20.3922 20.3604 19.6863 21.0625 18.8236 21.0625Z",
    fill: "#A3EA2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1433_2071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2353,
    height: 25,
    fill: "white",
    transform: "translate(0 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedRooms);
export default __webpack_public_path__ + "static/media/completed-rooms.5e9e55d54521b5e5f58372d8c429aa27.svg";
export { ForwardRef as ReactComponent };